import React from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import AdminLayoutWrapper from "@components/layout/AdminLayoutWrapper";
import { getCurrentCulture } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

export function DepositInfoPage() {
	const { t } = useTranslation();

	return (
		<AdminLayoutWrapper>
			<div className="container">
				<div className="card--primary">
					<div className="card--primary__body">
						<div className="card--primary__header card--primary__header--icon">
							<i className="u-icon u-icon--huge u-icon--pending"></i>
							<div className="u-mar--top--xsml u-type--lrg">
								{t("PAYMENT_INFO.PAYMENT_DETAILS")}
							</div>
						</div>

						<div className="u-type--base u-type--center u-mar--bottom--big">
							{t("PAYMENT_INFO.PAYLADO_TRANSACTION_MESSAGE")}
						</div>

						<Link
							to={`/${getCurrentCulture()}/${DefaultPath.HOME}`}
							className="card--message__cta btn btn--base btn--accent u-mar--top--big"
							data-at="at-accountActivationOk"
						>
							{t("PAYMENT_INFO.HOME_PAGE")}
						</Link>
					</div>
				</div>
			</div>
		</AdminLayoutWrapper>
	);
}
